"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClientEventHandler = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const agora_rtc_sdk_ng_1 = require("agora-rtc-sdk-ng");
const base_1 = require("../base");
const IrisClientManager_1 = require("../engine/IrisClientManager");
const IrisClientObserver_1 = require("../engine/IrisClientObserver");
const util_1 = require("../util");
class IrisClientEventHandler {
    constructor(irisClient, engine) {
        // AUDIT-v18: traccia i listener registrati per rimuoverli puntualmente in
        // release(). removeAllListeners() funziona, ma eventuali nuovi on() registrati
        // via Dart plugin o multi-instance verrebbero rimossi anche loro. Meglio
        // rimuovere SOLO ciò che abbiamo aggiunto — più safe in long-session.
        this._bound = [];
        this._irisClient = irisClient;
        this._engine = engine;
        this.agoraRTCClient = irisClient.agoraRTCClient;
        // AUDIT-v18: helper per registrare in modo consistente + tracciare per release.
        const reg = (event, handler) => {
            this.agoraRTCClient.on(event, handler);
            this._bound.push({ event, handler });
        };
        reg('connection-state-change', this.onEventConnectionStateChange.bind(this));
        reg('user-joined', this.onEventUserJoined.bind(this));
        reg('user-left', this.onEventUserLeft.bind(this));
        reg('user-published', this.onEventUserPublished.bind(this));
        reg('user-unpublished', this.onEventUserUnpublished.bind(this));
        reg('stream-message', this.onStreamMessage.bind(this));
        reg('media-reconnect-start', this.onEventMediaReconnectStart.bind(this));
        reg('media-reconnect-end', this.onEventMediaReconnectEnd.bind(this));
        reg('stream-type-changed', this.onEventStreamTypeChanged.bind(this));
        reg('stream-fallback', this.onEventStreamFallback.bind(this));
        reg('volume-indicator', this.onEventVolumeIndicator.bind(this));
        reg('crypt-error', this.onEventCryptError.bind(this));
        reg('token-privilege-will-expire', this.onEventTokenPrivilegeWillExpire.bind(this));
        reg('token-privilege-did-expire', this.onEventTokenPrivilegeDidExpire.bind(this));
        reg('network-quality', this.onEventNetworkQuality.bind(this));
        reg('live-streaming-error', this.onEventLiveStreamingError.bind(this));
        reg('live-streaming-warning', this.onEventLiveStreamingWarning.bind(this));
        reg('exception', this.onEventException.bind(this));
        reg('is-using-cloud-proxy', this.onEventIsUsingCloudProxy.bind(this));
        reg('join-fallback-to-proxy', this.onEventJoinFallbackToProxy.bind(this));
        reg('content-inspect-error', this.onEventContentInspectError.bind(this));
        reg('content_inspect_result', this.onEventContentInspectResult.bind(this));
    }
    onEventConnectionStateChange(curState, revState, reason) {
        if (curState == 'DISCONNECTED')
            this._engine.rtcEngineEventHandler.onConnectionLost_c81e1a4(this._irisClient.connection);
        else if (reason == agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.CHANNEL_BANNED ||
            reason == agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.IP_BANNED ||
            reason == agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.UID_BANNED) {
            this._engine.rtcEngineEventHandler.onConnectionBanned_c81e1a4(this._irisClient.connection);
        }
        else if (reason == agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.NETWORK_ERROR ||
            reason == agora_rtc_sdk_ng_1.ConnectionDisconnectedReason.SERVER_ERROR) {
            this._engine.rtcEngineEventHandler.onConnectionInterrupted_c81e1a4(this._irisClient.connection);
        }
        if (curState != 'DISCONNECTING') {
            let state = util_1.AgoraTranslate.ConnectionState2NATIVE_RTCCONNECTION_STATE_TYPE(curState);
            let reason2 = NATIVE_RTC.CONNECTION_CHANGED_REASON_TYPE
                .CONNECTION_CHANGED_INTERRUPTED;
            if (reason != null) {
                reason2 = util_1.AgoraTranslate.ConnectionDisconnectedReason2NATIVE_RTCCONNECTION_CHANGED_REASON_TYPE(reason);
            }
            this._engine.rtcEngineEventHandler.onConnectionStateChanged_4075a9c(this._irisClient.connection, state, reason2);
        }
    }
    /*
     *  假设我们主客户端A和子客户端B，同时加入频道1， 此时另外一个用户C加入了频道1
     *  1.用户C 加入离开,开始推流,结束推流等行为会触发2次
     *  2.主客户端A会触发 用户B加入(需要过滤掉这个值)
     *  3.子客户端B会触发 用户A加入(需要过滤点这个值)
     **/
    onEventUserJoined(user) {
        var _a;
        // Fix user-account mode: in joinChannelWithUserAccount, agoraRTCClient.uid
        // is the STRING userAccount, not the numeric _uintid. Using it as localUid
        // here creates a connection that never matches irisClient.connection
        // (which was built with numeric _uintid in joinChannel). Fallout: every
        // subsequent getIrisClientByConnection lookup via remoteUserPackage.connection
        // returns undefined, so subscribeVideo/AudioTrack silently skip — no remote
        // media ever plays. Use the irisClient's canonical connection instead.
        let connection = (_a = this._irisClient.connection) !== null && _a !== void 0 ? _a : {
            channelId: this.agoraRTCClient.channelName,
            localUid: this.agoraRTCClient.uid,
        };
        let remoteUid = (0, util_1.getUidFromRemoteUser)(user);
        let elapsed = 0;
        this._engine.rtcEngineEventHandler.onUserJoined_c5499bd(connection, remoteUid, elapsed);
        //if joinchannel with string uid
        if (typeof user.uid === 'string') {
            //@ts-ignore websdk的私有属性
            let _uintid = user._uintid;
            let userInfo = {
                uid: _uintid,
                userAccount: user.uid,
            };
            this._engine.rtcEngineEventHandler.onUserInfoUpdated_2120245(_uintid, userInfo);
            this._engine.irisClientManager.addUserInfo(userInfo);
        }
        // Fix onuserjoin (ported from v0.9.1-rc.2 commit fd5eb6c, with multi-remote
        // correction): rc.2 overwrites uid on ALL packages of the connection, which
        // breaks when the same connection has multiple remotes (e.g. teacher camera +
        // teacher screen share — both published from the same channel).
        // Correct flow:
        //   1. If a package with uid === remoteUid already exists → no-op.
        //   2. Else if a package with uid === 0 (placeholder) exists → assign uid.
        //   3. Else → create new package.
        let userPackages = this._engine.irisClientManager.getRemoteUserPackagesByConnection(connection);
        let alreadyMapped = userPackages.find((p) => p.uid === remoteUid);
        if (!alreadyMapped) {
            let placeholder = userPackages.find((p) => !p.uid || p.uid === 0);
            if (placeholder) {
                placeholder.uid = remoteUid;
            }
            else {
                let userPackage = new IrisClientManager_1.RemoteUserPackage(connection, '', base_1.defaultRemoteVideoPlayerConfig, remoteUid, NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_REMOTE, base_1.IrisAudioSourceType.kAudioSourceTypeRemote);
                this._engine.irisClientManager.addRemoteUserPackage(userPackage, this.agoraRTCClient);
            }
        }
        this._engine.rtcEngineEventHandler.onRemoteAudioStateChanged_056772e(this._irisClient.connection, remoteUid, user.hasAudio
            ? NATIVE_RTC.REMOTE_AUDIO_STATE.REMOTE_AUDIO_STATE_STARTING
            : NATIVE_RTC.REMOTE_AUDIO_STATE.REMOTE_AUDIO_STATE_STOPPED, user.hasAudio
            ? NATIVE_RTC.REMOTE_AUDIO_STATE_REASON
                .REMOTE_AUDIO_REASON_REMOTE_UNMUTED
            : NATIVE_RTC.REMOTE_AUDIO_STATE_REASON.REMOTE_AUDIO_REASON_REMOTE_MUTED, 0);
        this._engine.rtcEngineEventHandler.onRemoteVideoStateChanged_a14e9d1(this._irisClient.connection, remoteUid, user.hasVideo
            ? NATIVE_RTC.REMOTE_VIDEO_STATE.REMOTE_VIDEO_STATE_STARTING
            : NATIVE_RTC.REMOTE_VIDEO_STATE.REMOTE_VIDEO_STATE_STOPPED, user.hasVideo
            ? NATIVE_RTC.REMOTE_VIDEO_STATE_REASON
                .REMOTE_VIDEO_STATE_REASON_REMOTE_UNMUTED
            : NATIVE_RTC.REMOTE_VIDEO_STATE_REASON
                .REMOTE_VIDEO_STATE_REASON_REMOTE_MUTED, 0);
    }
    onEventUserLeft(user, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            let remoteUid = (0, util_1.getUidFromRemoteUser)(user);
            let remoteUser = this._engine.irisClientManager.getRemoteUserPackageByUid(remoteUid);
            let reason2 = util_1.AgoraTranslate.string2NATIVE_RTCUSER_OFFLINE_REASON_TYPE(reason);
            this._engine.rtcEngineEventHandler.onUserOffline_0a32aac(this._irisClient.connection, remoteUid, reason2);
            //if joinchannel with string uid
            if (typeof user.uid === 'string') {
                this._engine.irisClientManager.removeUserInfoByUid(remoteUid);
            }
            // P0.6 (GEN-audit): upstream aveva due UNSUBSCRIBE_AUDIO_TRACK identici
            // (typo). Mancava UNSUBSCRIBE_VIDEO_TRACK → video remote restava allocato
            // dopo user-left → memory leak + rare ghost tile.
            // AUDIT-v18: null guard su remoteUser. Se ricezione user-left senza
            // precedente user-published (race post-kick), remoteUser è undefined,
            // il vecchio codice passava [undefined] a notifyRemote → NPE dentro loop.
            if (remoteUser) {
                yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK, [remoteUser]);
                yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK, [remoteUser]);
            }
            // AUDIT-v18: usa remoteUid numerico invece di user.uid raw (che in
            // user-account mode è la stringa userAccount → mai match in splice loop
            // perché userPackage.uid è number).
            this._engine.irisClientManager.removeRemoteUserPackage(remoteUid);
            this._engine.irisClientManager.removetrackEventHandlerByRemoteUser(user, 'all');
        });
    }
    onEventUserPublished(user, mediaType) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let remoteUid = (0, util_1.getUidFromRemoteUser)(user);
            let isLocal = user.uid === this.agoraRTCClient.uid;
            let remoteUser = this._engine.irisClientManager.getRemoteUserPackageByUid(remoteUid);
            // AUDIT-v18: self-heal. In rari casi user-published arriva prima di
            // user-joined (race, o dopo reconnect con state parziale). Creiamo il pkg
            // al volo invece di ignorare silenziosamente l'evento → evita remote
            // audio/video muto perennemente.
            if (!remoteUser) {
                util_1.AgoraConsole.warn(`onEventUserPublished: pkg mancante per uid=${remoteUid}, creo al volo`);
                remoteUser = new IrisClientManager_1.RemoteUserPackage((_a = this._irisClient.connection) !== null && _a !== void 0 ? _a : {
                    channelId: this.agoraRTCClient.channelName,
                    localUid: this.agoraRTCClient.uid,
                }, '', base_1.defaultRemoteVideoPlayerConfig, remoteUid, NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_REMOTE, base_1.IrisAudioSourceType.kAudioSourceTypeRemote);
                this._engine.irisClientManager.addRemoteUserPackage(remoteUser, this.agoraRTCClient);
            }
            if (remoteUser) {
                if (mediaType == 'audio') {
                    yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK, [remoteUser], false);
                    this._engine.rtcEngineEventHandler.onUserMuteAudio_0aac2fe(this._irisClient.connection, remoteUid, false);
                    if (!isLocal) {
                        this._engine.rtcEngineEventHandler.onRemoteAudioStateChanged_056772e(this._irisClient.connection, remoteUid, NATIVE_RTC.REMOTE_AUDIO_STATE.REMOTE_AUDIO_STATE_STARTING, NATIVE_RTC.REMOTE_AUDIO_STATE_REASON
                            .REMOTE_AUDIO_REASON_REMOTE_UNMUTED, 0);
                    }
                    if (user.audioTrack) {
                        if (this._engine.globalState.isAudioFrameParametersSet) {
                            user.audioTrack.setAudioFrameCallback((buffer) => {
                                var _a, _b, _c, _d;
                                let channelId = (_d = (_c = (_b = (_a = this._engine.irisClientManager.localAudioTrackPackages.find((e) => e.track === user.audioTrack)) === null || _a === void 0 ? void 0 : _a.irisClient) === null || _b === void 0 ? void 0 : _b.connection) === null || _c === void 0 ? void 0 : _c.channelId) !== null && _d !== void 0 ? _d : '';
                                // Convert AudioBuffer to Uint8Array
                                const channelData = buffer.getChannelData(this._engine.globalState.audioFrameParameters.channel); // Get data from first channel
                                const byteArray = new Uint8Array(channelData.buffer);
                                this._engine.mediaEngineEventHandler.onPlaybackAudioFrame_4c8de15(channelId, {
                                    buffer: byteArray,
                                    samplesPerChannel: length / buffer.numberOfChannels,
                                    channels: buffer.numberOfChannels,
                                    samplesPerSec: buffer.sampleRate * buffer.numberOfChannels,
                                });
                            }, this._engine.globalState.audioFrameParameters.samplesPerCall);
                        }
                    }
                }
                else if (mediaType == 'video') {
                    yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK, [remoteUser], false);
                    this._engine.rtcEngineEventHandler.onUserMuteVideo_0aac2fe(this._irisClient.connection, remoteUid, false);
                    if (!isLocal) {
                        this._engine.rtcEngineEventHandler.onRemoteVideoStateChanged_a14e9d1(this._irisClient.connection, remoteUid, NATIVE_RTC.REMOTE_VIDEO_STATE.REMOTE_VIDEO_STATE_STARTING, NATIVE_RTC.REMOTE_VIDEO_STATE_REASON
                            .REMOTE_VIDEO_STATE_REASON_REMOTE_UNMUTED, 0);
                    }
                }
            }
        });
    }
    onEventUserUnpublished(user, mediaType) {
        return __awaiter(this, void 0, void 0, function* () {
            let remoteUid = (0, util_1.getUidFromRemoteUser)(user);
            let remoteUser = this._engine.irisClientManager.getRemoteUserPackageByUid(remoteUid);
            if (remoteUser) {
                if (mediaType == 'audio') {
                    yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK, [remoteUser]);
                    this._engine.rtcEngineEventHandler.onUserMuteAudio_0aac2fe(this._irisClient.connection, remoteUid, true);
                    this._engine.rtcEngineEventHandler.onRemoteAudioStateChanged_056772e(this._irisClient.connection, remoteUid, NATIVE_RTC.REMOTE_AUDIO_STATE.REMOTE_AUDIO_STATE_STOPPED, NATIVE_RTC.REMOTE_AUDIO_STATE_REASON.REMOTE_AUDIO_REASON_REMOTE_MUTED, 0);
                    if (user.audioTrack) {
                        if (this._engine.globalState.isAudioFrameParametersSet) {
                            user.audioTrack.setAudioFrameCallback(null, this._engine.globalState.audioFrameParameters.samplesPerCall);
                        }
                    }
                }
                else if (mediaType == 'video') {
                    yield this._engine.irisClientManager.irisClientObserver.notifyRemote(IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK, [remoteUser]);
                    this._engine.rtcEngineEventHandler.onUserMuteVideo_0aac2fe(this._irisClient.connection, remoteUid, true);
                    this._engine.rtcEngineEventHandler.onRemoteVideoStateChanged_a14e9d1(this._irisClient.connection, remoteUid, NATIVE_RTC.REMOTE_VIDEO_STATE.REMOTE_VIDEO_STATE_STOPPED, NATIVE_RTC.REMOTE_VIDEO_STATE_REASON
                        .REMOTE_VIDEO_STATE_REASON_REMOTE_MUTED, 0);
                }
            }
        });
    }
    onStreamMessage(uid, payload) {
        var _a;
        //if joinchannel with string uid
        if (typeof uid === 'string') {
            uid = (_a = this._engine.irisClientManager.getUserInfoByUserAccount(uid)) === null || _a === void 0 ? void 0 : _a.uid;
        }
        this._engine.rtcEngineEventHandler.onStreamMessage_99898cb(this._irisClient.connection, uid, this._engine.globalState.streamMessageStreamId, payload, payload.length, 0);
    }
    onEventMediaReconnectStart(uid) {
        //暂时没有找到对应的回调
    }
    onEventMediaReconnectEnd(uid) {
        //展示没有找到合适的回调
    }
    onEventStreamTypeChanged(uid, streamType) {
        //展示没有合适的回调
    }
    onEventStreamFallback(uid, isFallbackOrRecover) {
        var _a;
        //if joinchannel with string uid
        if (typeof uid === 'string') {
            uid = (_a = this._engine.irisClientManager.getUserInfoByUserAccount(uid)) === null || _a === void 0 ? void 0 : _a.uid;
        }
        this._engine.rtcEngineEventHandler.onRemoteSubscribeFallbackToAudioOnly_dbdc15a(uid, isFallbackOrRecover == 'fallback' ? true : false);
    }
    onEventVolumeIndicator(result) {
        var _a, _b;
        // GEN-152: uid→numeric translation per user-account mode.
        // agora-rtc-sdk-ng emette volume-indicator con uid stringa (userAccount)
        // quando join è fatto con joinChannelWithUserAccount. Il Flutter binding
        // AudioVolumeInfo.uid è int: senza traduzione lo speaker uid arriva 0/null
        // e volumeByUid non si popola per i remoti. Traduciamo via userInfoList
        // (popolata da registerLocalUserAccount / user-joined handlers).
        const translated = [];
        for (let i = 0; i < result.length; i++) {
            const raw = result[i];
            let numericUid;
            if (typeof raw.uid === 'string') {
                // Local uid in user-account mode: match contro l'agoraRTCClient.uid
                // (stringa userAccount). Se è il local, usa il numeric uid noto.
                if (raw.uid === this.agoraRTCClient.uid) {
                    const connUid = (_a = this._irisClient.connection) === null || _a === void 0 ? void 0 : _a.localUid;
                    numericUid = typeof connUid === 'number' ? connUid : 0;
                }
                else {
                    const userInfo = this._engine.irisClientManager.getUserInfoByUserAccount(raw.uid);
                    if (userInfo && typeof userInfo.uid === 'number') {
                        numericUid = userInfo.uid;
                    }
                    else {
                        // UserAccount non ancora registrato (race con user-joined):
                        // skippa questo frame, non inventare uid.
                        continue;
                    }
                }
            }
            else {
                numericUid = raw.uid;
            }
            translated.push({ level: raw.level, uid: numericUid });
        }
        let speakers = [];
        for (let i = 0; i < translated.length; i++) {
            speakers.push(util_1.AgoraTranslate.volumeIndicatorResult2NATIVE_RTCAudioVolumeInfo(translated[i]));
        }
        let speakerNumber = translated.length;
        /* todo
         * - In the local user's callback, `totalVolume` is the sum of the voice volume and audio-mixing volume
         * of the local user.
         * - In the remote users' callback, `totalVolume` is the sum of the voice volume and audio-mixing volume
         * of all the remote speakers.
         */
        let totalVolume = 0;
        if (!this._engine.globalState.enableAudioVolumeIndicationConfig.reportVad) {
            // Confronta contro numeric local uid (post-traduzione).
            const localNumericUid = (_b = this._irisClient.connection) === null || _b === void 0 ? void 0 : _b.localUid;
            speakers = speakers.filter((speaker) => speaker.uid !== localNumericUid);
        }
        this._engine.rtcEngineEventHandler.onAudioVolumeIndication_781482a(this._irisClient.connection, speakers, speakerNumber, totalVolume);
    }
    onEventCryptError() {
        let errorType = NATIVE_RTC.ENCRYPTION_ERROR_TYPE.ENCRYPTION_ERROR_INTERNAL_FAILURE;
        this._engine.rtcEngineEventHandler.onEncryptionError_e7a65fe(this._irisClient.connection, errorType);
    }
    onEventTokenPrivilegeWillExpire() {
        this._engine.rtcEngineEventHandler.onTokenPrivilegeWillExpire_8225ea3(this._irisClient.connection, this._irisClient.irisClientState.token);
    }
    onEventTokenPrivilegeDidExpire() {
        this._engine.rtcEngineEventHandler.onRequestToken_c81e1a4(this._irisClient.connection);
    }
    onEventNetworkQuality(stats) {
        var _a;
        // Fix user-account mode: see note in onEventUserJoined.
        let connection = (_a = this._irisClient.connection) !== null && _a !== void 0 ? _a : {
            channelId: this.agoraRTCClient.channelName,
            localUid: this.agoraRTCClient.uid,
        };
        this._engine.rtcEngineEventHandler.onNetworkQuality_34d8b3c(connection, 0, stats.downlinkNetworkQuality, stats.uplinkNetworkQuality);
    }
    //todo 后边再做
    onEventLiveStreamingError(url, err) { }
    //todo 后边再做
    onEventLiveStreamingWarning(url, warning) { }
    onEventException(event) {
        // AUDIT-v18: esposizione errori SDK. In long-session capita exception
        // silenti (es. AUDIO_INPUT_LEVEL_TOO_LOW, FRAMERATE_INPUT_TOO_LOW); almeno
        // logghiamoli per diagnostica.
        util_1.AgoraConsole.warn(`[AgoraException] code=${event === null || event === void 0 ? void 0 : event.code} msg=${event === null || event === void 0 ? void 0 : event.msg} uid=${event === null || event === void 0 ? void 0 : event.uid}`);
    }
    onEventIsUsingCloudProxy(isUsingProxy) {
        //todo 暂时没有找到对应的回调
    }
    onEventJoinFallbackToProxy(proxyServer) {
        //todo 暂时没有找到对应的回调
    }
    onEventContentInspectError(error) {
        this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, (error === null || error === void 0 ? void 0 : error.message) || 'Content Inspect Error');
    }
    onEventContentInspectResult(data, error) {
        if (data) {
            let result = util_1.AgoraTranslate.data2NATIVE_RTC_CONNECT_INSPECT_RESULT(data);
            this._engine.rtcEngineEventHandler.onContentInspectResult_ba185c8(result);
        }
    }
    release() {
        // AUDIT-v18: rimozione puntuale dei listener tracciati. Evita il side-effect
        // di removeAllListeners che spoglia anche listener registrati esternamente
        // (es. dal Dart plugin Agora per gestire connection-state sulla UI).
        try {
            for (const { event, handler } of this._bound) {
                try {
                    this.agoraRTCClient.off(event, handler);
                }
                catch (_a) { }
            }
        }
        finally {
            this._bound = [];
        }
    }
}
exports.IrisClientEventHandler = IrisClientEventHandler;
